import React from 'react'

import useAppSelector from '../../../../store/hooks/useAppSelector'
import { appErrorModalConfigSelector } from '../../store/appSelectors'
import { ErrorModalType } from '../../types'
import BoxPickupUnavailableProductList from '../../../checkout/components/BoxPickupUnavailableProductList'
import CheckoutItemsOverrideMenuConflictList from '../../../checkout/components/CheckoutItemsOverrideMenuConflictList'
import CheckoutInvalidItemsList from '../../../checkout/components/CheckoutInvalidItemsList'

export default function ErrorModalAdditionalInfo() {
  const errorModalConfig = useAppSelector(appErrorModalConfigSelector)

  switch (errorModalConfig?.errorModalType) {
    case ErrorModalType.CheckoutBoxPickupUnAvailableProducts:
      return <BoxPickupUnavailableProductList />

    case ErrorModalType.CheckoutUnavailableProductsDueToOverrideMenu:
      return <CheckoutItemsOverrideMenuConflictList />

    case ErrorModalType.CheckoutItemsNotValid:
      return <CheckoutInvalidItemsList />

    default:
      return null
  }
}
